// Kept independent from App.js's FRONTEND_URL export to avoid a circular
// import (App.js -> NucarLogo -> brandConfig.js -> App.js); same fallback.
const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000";

// Mutable singleton holding the active brand identity. Defaults are
// byte-identical to today's hardcoded Nucar values, so an unpopulated
// brandConfig produces today's exact output.
export const brandConfig = {
  name: "NucarNext",
  // logoDark: dark artwork, used on light backgrounds (light={false})
  // logoLight: light artwork, used on dark backgrounds (light={true})
  logoDark: `${FRONTEND_URL}/nucarnext-logo-dark.png`,
  logoLight: `${FRONTEND_URL}/nucarnext-logo.png`,
  noLogo: false,
  // Dealership phone number for the locked-offer screen's "Call Us" button.
  // No default — omitting nextSettings.phone in Sanity simply hides that
  // button, same convention as tradeAdfEmail disabling ADF lead delivery.
  phone: null,
  // The resolved partner key for this widget instance, if any (see
  // index.js). Threaded through to backend calls like /offers/lock so
  // partner-specific delivery (eg. ADF trade leads) knows who to notify.
  partnerKey: null,
};

export function setBrandConfig(partial = {}) {
  if (partial.name) brandConfig.name = partial.name;
  if (partial.logoUrl) brandConfig.logoDark = partial.logoUrl;
  if (partial.footerLogoUrl) brandConfig.logoLight = partial.footerLogoUrl;
  if (typeof partial.noLogo === "boolean") brandConfig.noLogo = partial.noLogo;
  if (partial.phone) brandConfig.phone = partial.phone;
  if (partial.partnerKey) brandConfig.partnerKey = partial.partnerKey;
}
